<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oikfYP/tc-custom/9781504041751.jpg?1726519015146" alt="This image is the cover for the book Death Sentence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death Sentence
      </h1>
      <p class="bookDescription body article font2">
        <b>The true account of the man who murdered his family in their New Jersey mansion—and eluded a nationwide manhunt for eighteen years.</b><br/><br/> Until 1971, life was good for mild-mannered accountant John List. He was vice president of a Jersey City bank and had moved his mother, wife, and three teenage children into a nineteen-room home in Westfield, New Jersey. But all that changed when he lost his job. Raised by his Lutheran father to believe success meant being a good provider, List saw himself as an utter failure. Straining under financial burdens, the stress of hiding his unemployment, as well as the fear that the free-spirited 1970s would corrupt the souls of his children, List came to a shattering conclusion.<br/>  <br/> “It was my belief that if you kill yourself, you won’t go to heaven,” List told Connie Chung in a television interview. “So eventually I got to the point where I felt that I could kill them. Hopefully they would go to heaven, and then maybe I would have a chance to later confess my sins to God and get forgiveness.”<br/>  <br/> List methodically shot his entire family in their home, managing to conceal the deaths for weeks with a carefully orchestrated plan of deception. Then he vanished and started over as Robert P. Clark. Chronicling List’s life before and after the grisly crime, <i>Death Sentence</i> exposes the truth about the accountant-turned-killer, including his revealing letter to his pastor, his years as a fugitive with a new name—and a new wife—his eventual arrest, and the details of his high-profile trial.<br/>  <br/><i>Revised and updated, this ebook also includes photos.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Sharkey
      </h2>
      
      <p class="authorDescription body article">Joe Sharkey was a weekly columnist for the <I>New York Times </I>for nineteen years. Previously, he was an assistant national editor at the <I>Wall Street Journal</I> and a reporter and columnist with the <I>Philadelphia Inquirer</I>. The author of four books of nonfiction and one novel, Sharkey is currently an adjunct professor of journalism at the University of Arizona. He and his wife live in Tucson.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cc489bb